module.exports = __webpack_public_path__ + "static/media/br.992f5f73.svg";